interface Column {
  name?: string;
  label?: string;
  render?: (args: {
    row: any;
    column: Column;
    name?: string;
    rowIndex: number;
    colIndex: number;
  }) => any;
}

interface DataTableProps {
  name?: string;
  data?: any[];
  columns?: Column[];
}

export default function DataTable(props: DataTableProps) {
  const { data = [], columns = [], name } = props;

  return (
    <table className="table">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={index}>{column.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((column, colIndex) => (
              <td key={colIndex}>
                {column.render &&
                  column.render({
                    row,
                    column,
                    name: name
                      ? `${name}[${rowIndex}].${column.name}`
                      : column.name,
                    rowIndex,
                    colIndex,
                  })}
                {!column.render && column.name && row[column.name]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
